import { Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingTableContent } from "../Shared/LoadingTableContent";
import { YourApplicationModel } from "../../../apis/ApisYourApplications";

export type YourApplicationsTableProps = {
    applications: YourApplicationModel[]
}

export function YourApplicationsTable(props: YourApplicationsTableProps) {
    const app = useContext(AppContext);

    return (<>
        <div className="card shadow mb-5 widescreen-only mt-3">
            <div className="overflow-scroll-table">
                <table className="ApplicationHistoryTable DarkerHover table mt-0 mb-0 table-hover">
                    <thead className="table-secondary no-highlight">
                        <tr>
                            <th><i title={`Reference`} className="fa-solid fa-hashtag me-1"></i> Ref</th>
                            <th><i title={`Job title`} className="fa-solid fa-briefcase me-1"></i> Job title</th>
                            <th><i title={app.positions?.Features.DisplayText_Department}  className="fa-solid fa-building-columns me-1"></i> {app.positions?.Features.DisplayText_Department}</th>
                            {app.positions?.Features.JobBoard_PracticeGroup && <th><i title={app.positions?.Features.DisplayText_PracticeGroup} className="fa-solid fa-people-group me-1"></i> {app.positions?.Features.DisplayText_PracticeGroup}</th>}
                            <th><i title={`Location`} className="fa-solid fa-location-dot me-1"></i> Location</th>
                            <th><i title={`Status`} className="fa-solid fa-circle-info me-1"></i> Status</th>
                            <th><i title={`Closing date`} className="fa-solid fa-calendar-days me-1"></i> Closing date</th>
                            <th className="col-fit-content"></th>
                            <th className="col-fit-content"></th>
                            <th className="col-fit-content final-link-padding"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <LoadingTableContent colspan={app.positions?.Features.JobBoard_PracticeGroup ? 9 : 8} loading={props.applications == null} classes="text-center ignoreHover">
                            {props?.applications != null && props.applications.length > 0 ? <>
                                {props?.applications.map(ap => {
                                    return tableRow({ position: ap, PracticeGroupView: app.positions?.Features.JobBoard_PracticeGroup, DisplayText_Department: app.positions?.Features.DisplayText_Department, DisplayText_PracticeGroup: app.positions?.Features.DisplayText_PracticeGroup });
                                })}
                            </> : <>
                                <tr className="ignoreHover text-center" key={`EmptyRow`}>
                                    <td className="ignoreHover text-center text-muted no-highlight" colSpan={app.positions?.Features.JobBoard_PracticeGroup ? 9 : 8}>No applications</td>
                                </tr></>}
                        </LoadingTableContent>
                    </tbody>
                </table>
            </div>
        </div>
        <div className="mob-only">
            {props?.applications != null && props?.applications.map(ap => {
                return positionCard({ position: ap, PracticeGroupView: app.positions?.Features.JobBoard_PracticeGroup, DisplayText_Department: app.positions?.Features.DisplayText_Department, DisplayText_PracticeGroup: app.positions?.Features.DisplayText_PracticeGroup });
            })}
        </div>
    </>);
}

type YourApplicationsRowProps = {
    PracticeGroupView: boolean,
    position: YourApplicationModel
    DisplayText_PracticeGroup: string,
    DisplayText_Department: string,
}

const positionCard = (props: YourApplicationsRowProps) => {
    let ap = props.position;
    let isHasJustText = positionHasTextOrLink(props);
    return (<div className="card card-body mb-3" key={`PosCard_${ap.ApplicationNumber}`}>
        <div className="d-flex flex-column">
            <div className="pb-1">
                {isHasJustText && <h2>{ap.positionTitle}</h2>}
                {!isHasJustText && <h2><a className="alt-link" target="_blank" title={`Resume`} href={`/Form/?r=${ap.ApplicationNumber}`}>{ap.positionTitle}</a></h2>}
                <hr className="ShortBlock" />
            </div>
            {positionRow("fa-hashtag", "Reference", props.position.ApplicationNumber.toString())}
            {positionRow("fa-building", props.DisplayText_Department, props.position.ExternalDepartment)}
            {props.PracticeGroupView && positionRow("fa-people-group", props.DisplayText_PracticeGroup, props.position.PracticeGroup)}
            {positionRow("fa-location-dot", "Location", props.position.LocationText)}
            {positionRow("fa-circle-info", "Status", ((ap.Completed) ? "Completed" :
                ap.PositionStatus.toLocaleLowerCase() != "open" ? "Posn closed" :
                    (ap.PositionVisible || ap.CanApplyIfForwarded ? "In progress" : "Not available")))}
            {positionRow("fa-calendar-days", "Closing date", ap.closingdate != null ? new Date(ap.closingdate).toDateString() : "N/A")}
            <div className="py-2 d-flex flex-row justify-content-start gap-2">
                {(!ap.PositionVisible && ap.CanApplyIfForwarded) && ap.PositionType != 'SPECULATIVE' && <a className="btn btn-outline-soft" href={`/Intranet/PositionDetail.aspx?id=${ap.applyingforid}&preview=yes`} target="_blank">Details</a>}
                {!(!ap.PositionVisible && ap.CanApplyIfForwarded) && ap.PositionType != 'SPECULATIVE' && <Link className="btn btn-outline-soft" to={`/PositionDetails?id=${ap.applyingforid}`}>Details</Link>}
                {!isHasJustText && <a className="btn btn-outline-soft" title={`Resume`} target="_blank" href={`/Form/?r=${ap.ApplicationNumber}`}>Resume</a>}
                <a href={`/Preview/?app=${ap.ApplicationNumber}`} className="btn btn-outline-soft" target="_blank">View</a>
            </div>
        </div>
    </div>);
}

const positionRow = (iconClass: string, title: string, details: string) => {
    return (<div className="py-1 d-flex"><div className="w-50 text-alt-or-contrast"><i className={`fa-solid ${iconClass} me-1`}></i><b>{title}:</b> </div><div className="w-50">{details}</div></div>);
}

const positionHasTextOrLink = (props: YourApplicationsRowProps): boolean => {
    return (props.position.Completed || props.position.PositionStatus.toLocaleLowerCase() != "open" || (!props.position.PositionVisible && !props.position.CanApplyIfForwarded));;
}

const tableRow = (props: YourApplicationsRowProps) => {
    let ap = props.position;
    let isHasJustText = positionHasTextOrLink(props);
    return (
        <tr key={`${ap.ApplicationNumber}`}>
            <td>{ap.ApplicationNumber}</td>
            <td className="allowbreaking">
                {isHasJustText && <>{ap.positionTitle}</>}
                {!isHasJustText && <a title={`Resume`} target="_blank" href={`/Form/?r=${ap.ApplicationNumber}`}>{ap.positionTitle}</a>}
            </td>
            <td>{ap.ExternalDepartment}</td>
            {props.PracticeGroupView && <td>{ap.PracticeGroup}</td>}
            <td>{ap.LocationText}</td>
            <td>{
                ((ap.Completed) ? "Completed" :
                    ap.PositionStatus.toLocaleLowerCase() != "open" ? "Posn closed" :
                        (ap.PositionVisible || ap.CanApplyIfForwarded ? "In progress" : "Not available"))
            }</td>
            <td>{
                ap.closingdate != null ? new Date(ap.closingdate).toDateString() : "N/A"
            }</td>
            <td>
                 {!isHasJustText && <a title={`Resume`} target="_blank" href={`/Form/?r=${ap.ApplicationNumber}`}>Resume</a>}
            </td>
            <td>
                {(!ap.PositionVisible && ap.CanApplyIfForwarded) && ap.PositionType != 'SPECULATIVE' && <a href={`/Intranet/PositionDetail.aspx?id=${ap.applyingforid}&preview=yes`} target="_blank">Details</a>}
                {!(!ap.PositionVisible && ap.CanApplyIfForwarded) && ap.PositionType != 'SPECULATIVE' && <Link to={`/PositionDetails?id=${ap.applyingforid}`}>Details</Link>}
            </td>
            <td className="final-link-padding">
                <a href={`/Preview/?app=${ap.ApplicationNumber}`} target="_blank">View</a>
            </td>
        </tr>);
}